module.exports = __webpack_public_path__ + "static/media/liveroom-setting-sharecard.0769222e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-sharecard.png
// module id = 1976
// module chunks = 6